import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { LucideIconInput } from '@lucide/angular';
import { ToggleChipComponent } from '../toggle-chip/toggle-chip.component';

export interface ViewToggleOption<T = string> {
  value: T;
  icon: LucideIconInput;
  label: string;
}

@Component({
  selector: 'ptl-view-toggle',
  standalone: true,
  imports: [ToggleChipComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="ptl-view-toggle" [class.ptl-view-toggle--labels]="showLabels()" role="group" [attr.aria-label]="groupLabel()">
      @for (option of options(); track option.value) {
        <ptl-toggle-chip
          class="ptl-view-toggle__item"
          [label]="option.label"
          [icon]="option.icon"
          [active]="option.value === value()"
          [fullWidth]="showLabels()"
          [showLabel]="showLabels()"
          size="s"
          (clicked)="select(option)"
        ></ptl-toggle-chip>
      }
    </div>
  `,
  styleUrls: ['./ptl-view-toggle.component.scss'],
})
export class PtlViewToggleComponent<T = string> {
  options = input.required<ViewToggleOption<T>[]>();
  value = input.required<T>();
  groupLabel = input<string>('');
  /** Show each option's label as visible text (full-width segmented control) instead of an icon-only button. */
  showLabels = input(false);

  valueChange = output<T>();

  protected select(option: ViewToggleOption<T>): void {
    if (option.value !== this.value()) {
      this.valueChange.emit(option.value);
    }
  }
}
